import React, { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';

import './index.sass'

// eslint-disable-next-line import/prefer-default-export
const usePlayer = ({ src, controls = false, autoplay = true}) => {
    const options = {
        fluid: true,
        controls: controls,
        preload: 'auto',
        playbackRates: [1, 1.5, 2],
        suppressNotSupportedError: true
    };
    const videoRef = useRef(null);
    const [player, setPlayer] = useState(null);

    const sources = Array.isArray(src) ? src : [src];

    useEffect(() => {
        const vjsPlayer = videojs(videoRef.current, {
            ...options,
            sources,
        });

        setPlayer(vjsPlayer);

        return () => {
            player && player.dispose();
            setPlayer(null);
        }
    }, []);

    useEffect(() => {
        if (player) {
            player.src({ src });
        }
    }, [src]);

    useEffect(() => {
        if (player && autoplay) {
            player.ready(() => {
                player.play();
            })
        }
    }, [player])

    return videoRef;
};

const VideoPlayer = ({ src, width, height, autoplay, controls, loop=true, muted='muted', poster }) => {
    const playerRef = usePlayer({ src, width, height, autoplay, controls });

    return (
        <div data-vjs-player>
            <video ref={playerRef} muted={muted} loop={loop} className="video-js" poster={poster}/>
        </div>
    );
};

export default VideoPlayer;
